import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: null,
};

const aiTypeSlice = createSlice({
  name: "aiType",
  initialState,
  reducers: {
    setAiInfo: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setAiInfo } = aiTypeSlice.actions;
export default aiTypeSlice.reducer;
